/*************************************************/
/* Statistic                                     */
/*************************************************/

import "velocity-animate";

export class statistics {
    constructor(element) {
        if (element) {
            element.velocity(
                {
                    tween: [element.getAttribute('data-value'), 0]
                },
                {
                    easing: "easeOutCirc",
                    delay: 800,
                    duration: 3000,
                    progress: function (elements, complete, remaining, start, tweenValue,activeCall) {
                        element.innerHTML = Math.round(tweenValue.tween).toLocaleString()
                    }
                });
        }
    }
}

export default new statistics();